{
  "action": "Acción: ",
  "actionName": "Acción",
  "activeDatesLabel": "Fechas activas",
  "activeDatesValueWithStartAndEnd": "{{start, datetime}} - {{end, datetime}}",
  "activeDatesWithStart": "{{start, datetime}}",
  "cancel": "Cancelar",
  "datetimeWithVal": "{{val, datetime}}",
  "delete": "Borrar",
  "deleteThisSchedule": "¿Borrar este horario?",
  "endTimeLabel": "Fin",
  "executeAt": "Ejecutar en",
  "executeAtWithTimestamp": "{{timestamp, datetime}}",
  "executeOnceOn": "Ejecutar una vez:",
  "executeOnceOnWithDate": "Ejecutar una vez en {{val, datetime}}",
  "executionTime": "Tiempo de ejecución",
  "executionWithStartAndEnd": "{{start, datetime}} - {{end, datetime}}",
  "executionWithStartAndEndAndTimezone": "{{start, datetime}} - {{end, datetime}} {{timezone}}",
  "executionWithStartAndEndAndTimezoneNextDay": "{{start, datetime}} - {{end, datetime}} {{timezone}} (Día siguiente)",
  "executionWithStartAndEndNextDay": "{{start, datetime}} - {{end, datetime}} (día siguiente)",
  "executionWithStartNextDay": "{{start, datetime}} (Día siguiente)",
  "helpBody": "Los horarios se utilizan para encender y apagar bombas o válvulas en momentos específicos o durante períodos específicos. Los horarios se pueden configurar para que se ejecuten una vez o para que se repitan en días específicos de la semana.\n\nLos horarios deben sincronizarse con los dispositivos para funcionar correctamente, lo que debería suceder rápidamente, pero no de inmediato. Si no ve que su horario se ejecuta cuando lo espera, verifique el estado de sincronización. Si el estado de sincronización es \"Error de sincronización\", comuníquese con el soporte de FarmHQ.",
  "helpTitle": "Acerca de los horarios",
  "manageScheduleTitle": "Administrar programación",
  "new": "Nuevo",
  "nextDayParentheses": "(Día siguiente)",
  "nextScheduleActionWithTimestamp": "Próxima acción programada para el {{timestamp, datetime}}",
  "noSchedules": "No se encontraron acciones programadas para su cuenta de granja.",
  "noSchedulesActive": "No se encontraron horarios activos",
  "noSchedulesExpired": "No se encontraron acciones programadas pasadas.",
  "repeatWeeklyOnDays": "Repetir semanalmente los días:",
  "repeats": "Se repite:",
  "scheduledActions": "Acciones programadas",
  "schedulesActiveTitle": "Horarios activos",
  "schedulesExpiredTitle": "Horarios vencidos",
  "schedulesListTitle": "Horarios de riego",
  "startTimeLabel": "Comenzar",
  "status": "Estado",
  "syncStatus_FAILED": "Error de sincronización. Comuníquese con el servicio de asistencia.",
  "syncStatus_IN_PROGRESS": "Sincronizando con el dispositivo...",
  "syncStatus_SUCCESS": "Sincronizado con el dispositivo.",
  "theFollowingScheduledActionWillBeCancelled": "La siguiente acción programada será cancelada.",
  "thisWeek": "Esta semana:",
  "time": "Tiempo"
}
